// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
require('es6-promise').polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import vGet from './util/v_get.js'
import http from './util/httpConfig'
import ant, { message } from 'ant-design-vue'
import _ from 'lodash'
import FfcsImg from '@/components/FfcsImg/index.vue'
// import './assets/styles/html2gray.css'
const pushRouter = (name) => {
  router.push(name)
}

Vue.config.productionTip = false
Vue.prototype.message = message
Vue.prototype.vGet = vGet
Vue.prototype.http = http
Vue.prototype.pushRouter = pushRouter
Vue.prototype._ = _
Vue.use(ant)
Vue.component('ffcs-img',FfcsImg)

router.afterEach((to, from, next) => {//页面回到顶部 2022-12-16
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js